export default "__VITE_ASSET__jiZX66jf__"